import { useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { db } from "helpers/firebase/firebaseConfig";
import Cookies from "js-cookie";
import { fetchNotificationsRequest } from "store/actions";
import { throttle } from 'lodash';
import { onSnapshot, collection, query, where } from "firebase/firestore";

const NOTIFICATIONS_COLLECTION = "serviceProvidersNotifications";

const NotificationSubscription = ({ children }) => {
  const providerId = Cookies.get("usersessionId", {
    secure: true,
    sameSite: 'strict',
    path: "/"
  });
  const dispatch = useDispatch();

  // Throttled refresh function to prevent excessive dispatches
  const refreshNotifications = useCallback(throttle(() => {
    dispatch(fetchNotificationsRequest());
  }, 1000), [dispatch]);

  useEffect(() => {
    if (!providerId) return;

    // Create a query for this provider's notifications
    const notificationsQuery = query(
      collection(db, NOTIFICATIONS_COLLECTION),
      where("serviceProviders", "==", providerId)
    );

    // Set up real-time listener
    const unsubscribe = onSnapshot(
      notificationsQuery,
      (snapshot) => {
        // Only refresh if there are actual server changes (not local writes)
        if (!snapshot.metadata.hasPendingWrites) {
          refreshNotifications();
          
          // Optional: You could also play a notification sound here
          // for new notifications only by checking snapshot.docChanges()
        }
      },
      (error) => {
        console.error("Error listening to notifications:", error);
      }
    );

    return () => {
      unsubscribe();
      refreshNotifications.cancel(); // Cancel any pending throttled calls
    };
  }, [providerId, refreshNotifications]);

  return children;
};

export default NotificationSubscription;